module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Ultra.472b994.woff";